const translates = {
	en:{
		emptySelect:'not selected',
	},
	ru:{
		emptySelect:'не выбран',
	}
};
export default translates;